import AdminMain from "pages/Admin/Main";

export default function AdminMainPage() {
  return <AdminMain />;
}
